var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('div',{staticClass:"layout__wide"},[_c('headline',{attrs:{"title":"Featured Projects"}}),_c('div',{staticClass:"home__featured"},[_c('projects',{attrs:{"projects":_vm.featured}})],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"home__hero"},[_vm._v(" Digital Product"),_c('br'),_vm._v("Designer & Developer ")])
}]

export { render, staticRenderFns }